// Copyright 2021 Northern.tech AS
//
//    Licensed under the Apache License, Version 2.0 (the "License");
//    you may not use this file except in compliance with the License.
//    You may obtain a copy of the License at
//
//        http://www.apache.org/licenses/LICENSE-2.0
//
//    Unless required by applicable law or agreed to in writing, software
//    distributed under the License is distributed on an "AS IS" BASIS,
//    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//    See the License for the specific language governing permissions and
//    limitations under the License.
export const CHANGE_ALERT_CHANNEL = 'CHANGE_ALERT_CHANNEL';
export const RECEIVE_DEVICE_ALERTS = 'RECEIVE_DEVICE_ALERTS';
export const RECEIVE_DEVICE_MONITOR_CONFIG = 'RECEIVE_DEVICE_MONITOR_CONFIG';
export const RECEIVE_DEVICE_ISSUE_COUNTS = 'RECEIVE_DEVICE_ISSUE_COUNTS';
export const RECEIVE_LATEST_DEVICE_ALERTS = 'RECEIVE_LATEST_DEVICE_ALERTS';
export const SET_ALERT_LIST_STATE = 'SET_ALERT_LIST_STATE';
export const alertChannels = { email: 'email' };
